import { NotificationPageService } from './page/notification-page/service/notification-page.service';
import { Component, inject, OnInit } from '@angular/core';
import {
	faHome,
	faHeadset,
	faChartBar,
	faFileAlt,
	faAddressCard,
	faAngleRight,
	faBook,
	faDatabase,
	faBoxOpen,
	faSearchPlus,
	faExclamation,
	faUser,
	faBars,
	faListCheck,
	faEye,
	faSearch,
	faSignOutAlt,
	faTimes,
	faWindowMinimize,
	faCheck,
} from '@fortawesome/free-solid-svg-icons';

import { AuthLoginService } from './page/auth-page/service/auth-login.service';
import { Router, NavigationEnd, ActivatedRoute, NavigationStart } from '@angular/router';
import { LabelsService } from './util/services/labels/labels.service';
import { enduserInterface } from './util/interfaces/enduser';
import { ProfileService } from './services/profile/profile.service';

import { NotificationService } from './services/notification/notification.service';
import { customerInterface } from './util/interfaces/customer';
import { styleSheetInterface } from './util/interfaces/styleSheet';
import { PermissionService } from './util/services/permission/permission.service';
import { filter, map, mergeMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { GlobalService } from './services/global/global.service';
import { LoadingNotificationService } from './services/loading-notification/loading-notification.service';
import { ContextMenuService } from './services/context-menu/context-menu.service';
import { mspSelectOptions } from './page_component_item/form/msp-select/data/mspSelectI.interface';
import { MenuLateralService } from './components/menu-lateral/data/menu-lateral.service';
import { MspFaviconService } from './util/services/favicon/msp-favicon.service';
import { NavigationHistoryService } from './services/navigation-history/navigation-history.service';
import { StylesheetService } from './services/stylesheet/stylesheet.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
	private readonly Router = inject(Router);
	private readonly route = inject(ActivatedRoute);
	private readonly labelsService = inject(LabelsService);
	private readonly stylesheetService = inject(StylesheetService);
	private readonly mspFaviconService = inject(MspFaviconService);
	private readonly navigationHistoryService = inject(NavigationHistoryService);
	public readonly AuthLoginService = inject(AuthLoginService);
	public readonly PermissionService = inject(PermissionService);
	public readonly ProfileService = inject(ProfileService);
	public readonly menuLateralService = inject(MenuLateralService);
	public readonly NotificationService = inject(NotificationService);
	public readonly LoadingNotificationService = inject(LoadingNotificationService);
	public readonly ContextMenuService = inject(ContextMenuService);
	public readonly GlobalService = inject(GlobalService);
	public readonly NotificationPageService = inject(NotificationPageService);

	environment = environment;
	icons = {
		faHome: faHome,
		faHeadset: faHeadset,
		faChartBar: faChartBar,
		faFileAlt: faFileAlt,
		faAddressCard: faAddressCard,
		faBook: faBook,
		faDatabase: faDatabase,
		faBoxOpen: faBoxOpen,
		faListCheck: faListCheck,
		faSearchPlus: faSearchPlus,
		faExclamation: faExclamation,
		faUser: faUser,
		faAngleRight: faAngleRight,
		faBars: faBars,
		faEye: faEye,
		faSearch: faSearch,
		faSignOutAlt: faSignOutAlt,
		faTimes: faTimes,
		faWindowMinimize: faWindowMinimize,
		faCheck: faCheck,
	};

	labels: { [key: string]: string } = {};

	chooseTransition = 0;
	loadingTransition = ['split_diagonal', 'split_diagonal_alt', 'split_vertical', 'split_horizontal'];

	constructor() {}

	isLoadingLabels = true;
	isLoadingStyleSheetList = true;
	isLoadingStyleSheet = true;
	isLoadingProfile = true;
	isLoadingSessionStatus = true;
	isLoadingLogo = true;
	isLoadingRoute = false;
	isLoadingAvailableCustomers = false;

	loadingRouteTimeout: any;

	isMenuOpen = false;
	isAllNotificationsReaded = true;

	/* ABI */
	abiBubbleData = {
		isOpen: false,
		hold: false,
		holdStart: null,
		holdFinish: null,
		holdDelta: null,
		left: 0,
		top: 0,
	};
	/* EOABI */

	/*PROFILE*/
	isProfileMenuOpen = this.GlobalService.isProfileMenuOpen;
	isAnalystView: boolean;
	availableCustomers: customerInterface[] = [];
	availableCustomersOptions = () => {
		return this.availableCustomers.map((customer) => {
			const option: mspSelectOptions<string> = {
				id: customer.id,
				label: customer.customer,
				value: customer.id,
				selected: customer.id == this.ProfileService.userData().idCustomer,
			};
			return option;
		});
	};
	logoImagePath = '';
	/*EOPROFILE*/

	/*MODAL*/
	modalMessage: string;
	modalEvent: string;
	isModalOpen = false;
	/*EOMODAL*/

	isLoggedIn = false;
	isOnNotRequiredLoginPages = false;
	isOnNoMenuPages = false;
	showCustomerDropdown = true;

	selectedRoute = '';
	searchbarText: string | number = '';

	permissions = {
		showSearch: true,
	};

	ngOnInit() {
		this.mspFaviconService.setFavicon(this.mspFaviconService.getLogoSource());
		window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
			this.mspFaviconService.setFavicon(this.mspFaviconService.getLogoSource());
		});
		window.addEventListener(
			'storage',
			(e) => {
				if (e.key === 'updateEvent') {
					localStorage.removeItem('updateEvent');
					location.reload();
				}
			},
			false
		);

		window.addEventListener('resize', () => {
			this.initAbiPosition();
		});

		this.initAbiPosition();

		this.isLoggedIn = this.AuthLoginService.isLoggedIn();

		this.selectedRoute = '/' + window.location.pathname.split('/')[1];

		if (this.isLoggedIn && this.selectedRoute != '/404') {
			this.ProfileService.setLocalUser().subscribe({
				next: (userData) => {
					if (userData.sessionStatus.toString() === '') {
						//They were disconnected
						this.logoff();
						this.NotificationService.setNotificationMessage(this.labels.lbl_voce_foi_desconectado_reconecte);
						this.isLoadingStyleSheetList = false;
						this.isLoadingLabels = false;
						this.isLoadingProfile = false;
						this.isLoadingStyleSheet = false;
						this.isLoadingSessionStatus = false;
						return;
					}

					if (
						this.isLoggedIn &&
						(this.selectedRoute === '/home' || this.selectedRoute === '/login' || this.selectedRoute === '/')
					) {
						this.Router.navigateByUrl(this.ProfileService.userData().main_menu);
						this.selectedRoute = '/' + this.ProfileService.userData().main_menu;
						this.isOnNoMenuPages = false;
					}

					this.PermissionService.initPermissions();

					this.isLoadingProfile = false;

					this.GlobalService.darkModeOn.subscribe({
						next: (darkModeBool) => {
							this.logoImagePath = darkModeBool == true ? 'logo_dark' : 'logo_light';
							this.isLoadingLogo = false;
						},
					});

					this.isAnalystView = this.ProfileService.userData().sessionStatus.toString() === '1';
					if (
						!localStorage.getItem('sessionStatus') ||
						localStorage.getItem('sessionStatus').toString() != this.ProfileService.userData().sessionStatus.toString()
					) {
						this.AuthLoginService.setSessionStatus(
							this.ProfileService.userData().sessionStatus.toString()
								? this.ProfileService.userData().sessionStatus.toString()
								: this.ProfileService.userData().idAnalyst
									? '1'
									: '0'
						);
						location.reload();
					}

					this.AuthLoginService.setSessionStatus(
						this.ProfileService.userData().sessionStatus.toString()
							? this.ProfileService.userData().sessionStatus.toString()
							: this.ProfileService.userData().idAnalyst
								? '1'
								: '0'
					);
					this.isLoadingSessionStatus = false;

					if (
						!this.ProfileService.userData().css_pattern ||
						this.ProfileService.userData().css_pattern.toString().trim() === ''
					) {
						//Default msp css pattern
						this.ProfileService.userData().css_pattern = environment.defaultMspCssPaternId;
					}

					if (this.ProfileService.userData().css_pattern.toString() == environment.defaultMspCssPaternId.toString()) {
						this.ProfileService.getStyleSheetData(environment.defaultMspCssPaternId.toString())
							.subscribe({
								next: (cssStyleSheet) => {
									this.setTheme(cssStyleSheet);
								},
							})
							.add(() => {
								this.isLoadingStyleSheet = false;
							});
					} else {
						this.ProfileService.getStyleSheetData(this.ProfileService.userData().css_pattern.toString()).subscribe({
							next: (cssStyleSheet) => {
								if (cssStyleSheet.logo.content.length > 0) {
									this.logoImagePath = cssStyleSheet.logo.content;
								}

								this.setTheme(cssStyleSheet);
								this.isLoadingStyleSheet = false;
							},
							error: () => {
								//In case of error get the default stylesheet
								this.ProfileService.getStyleSheetData(environment.defaultMspCssPaternId.toString())
									.subscribe({
										next: (cssStyleSheet) => {
											this.setTheme(cssStyleSheet);
										},
									})
									.add(() => {
										this.isLoadingStyleSheet = false;
									});
							},
						});
					}

					this.isLoadingAvailableCustomers = true;
					this.ProfileService.setAvailableCustomers().subscribe((availableCustomers) => {
						this.availableCustomers = availableCustomers;
						this.isLoadingAvailableCustomers = false;

						const findCustomer = this.availableCustomers.find((customer) => {
							return this.ProfileService.userData().idCustomer.toString() === customer.id.toString();
						});
						if (!findCustomer) {
							this.logoff();
							return;
						}

						this.isLoadingAvailableCustomers = false;
					});
				},
				error: () => {
					this.AuthLoginService.checkSAMLLogoff(location.hostname)
						.subscribe({
							next: (redirect) => {
								this.AuthLoginService.removeSessionToken();
								location.href = redirect[0].redirect == '' ? '/login' : redirect[0].redirect;
								location.reload();
							},
							error: () => {
								this.AuthLoginService.removeSessionToken();
								location.href = '/login';
								location.reload();
							},
						})
						.add(() => {
							this.NotificationService.setNotificationMessage(this.labels.lbl_voce_foi_desconectado_reconecte);
							this.isLoadingStyleSheetList = false;
							this.isLoadingLabels = false;
							this.isLoadingProfile = false;
							this.isLoadingStyleSheet = false;
							this.isLoadingSessionStatus = false;
						});
				},
			});

			this.ProfileService.getStyleSheetList(false).subscribe(
				(styleSheetData) => {
					this.ProfileService.setStyleSheetList(styleSheetData);
					this.isLoadingStyleSheetList = false;
				},
				() => {
					this.isLoadingStyleSheetList = false;
				}
			);

			this.labelsService.getLabels().subscribe(
				(labels) => {
					this.labels = labels;
					this.isLoadingLabels = false;
				},
				() => {
					this.isLoadingLabels = false;
				}
			);
		} else {
			this.isLoadingStyleSheetList = false;
			this.isLoadingLabels = false;
			this.isLoadingProfile = false;
			this.isLoadingStyleSheet = false;
			this.isLoadingSessionStatus = false;
		}

		this.Router.events
			.pipe(
				filter((event) => event instanceof NavigationEnd),
				map(() => this.rootRoute(this.route)),
				filter((route: ActivatedRoute) => route.outlet === 'primary'),
				mergeMap((route: ActivatedRoute) => route.data)
			)
			.subscribe((event: { [name: string]: any }) => {
				if (event.rules && event.rules.length > 0) {
					event.rules.forEach((rule: string) => {
						if (rule === 'noMenu') this.isOnNoMenuPages = true;
					});
				}
				// Verifica a rota atual para exibir ou não o dropdown de clientes
				this.showCustomerDropdown = event.showCustomerDropdown !== false;
			});

		if (this.isLoggedIn && this.selectedRoute !== '/login') {
			this.NotificationPageService.getActiveNotifications().subscribe({
				next: (items) => {
					const storedItems = localStorage.getItem('notifications');
					let notifications: { id: string; read: boolean; customer: string }[] = storedItems ? JSON.parse(storedItems) : [];

					notifications = notifications.filter((notification) => items.includes(notification.id));
					localStorage.setItem('notifications', JSON.stringify(notifications));
				},
			});
		}
	}

	updateUserCustomer(idCustomer: string): void {
		const updateBody = this.ProfileService.getUpdateUserBody();
		document.body.style.cursor = 'wait';
		this.ProfileService.updateUser({ ...updateBody, idcust: idCustomer, idCustomer: idCustomer }).subscribe({
			next: () => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
				location.href = '/home';
			},
			error: () => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_erro_ao_salvar);
				document.body.style.cursor = 'default';
			},
		});
	}

	private rootRoute(route: ActivatedRoute): ActivatedRoute {
		while (route.firstChild) {
			route = route.firstChild;
		}
		return route;
	}

	setTheme(cssStyleSheet: styleSheetInterface): void {
		const root = document.documentElement;

		const hexUp = {
			'#': '',
			'0': '2',
			'1': '3',
			'2': '4',
			'3': '5',
			'4': '6',
			'5': '7',
			'6': '8',
			'7': '9',
			'8': 'a',
			'9': 'b',
			a: 'c',
			b: 'd',
			c: 'e',
			d: 'f',
			e: 'f',
			f: 'f',
		};

		this.ProfileService.setUserStylesheet(cssStyleSheet);

		const primaryColor1 = cssStyleSheet['primary-color-1'];
		const primaryColor2 = cssStyleSheet['primary-color-2'];
		const primaryColor1DarkMode = cssStyleSheet['primary-color-1-dark-mode'] ?? cssStyleSheet['primary-color-1'];
		const primaryColor2DarkMode = cssStyleSheet['primary-color-2-dark-mode'] ?? cssStyleSheet['primary-color-2'];

		root.style.setProperty(`--primary-color-1`, `light-dark(${primaryColor1}, ${primaryColor1DarkMode})`);
		root.style.setProperty(`--primary-color-2`, `light-dark(${primaryColor2}, ${primaryColor2DarkMode})`);

		let temporaryColor = '#';
		for (const letter of cssStyleSheet['primary-color-1'].split('')) {
			temporaryColor += hexUp[letter.toLowerCase()];
		}
		root.style.setProperty(`--primary-color-1-hover`, `light-dark(${temporaryColor}, ${temporaryColor})`);

		temporaryColor = '#';
		for (const letter of cssStyleSheet['primary-color-2'].split('')) {
			temporaryColor += hexUp[letter.toLowerCase()];
		}
		root.style.setProperty(`--primary-color-2-hover`, `light-dark(${temporaryColor}, ${temporaryColor})`);

		this.stylesheetService.setStylesheetColor('primary-color-1', primaryColor1);
		this.stylesheetService.setStylesheetColor('primary-color-2', primaryColor2);
		this.stylesheetService.setStylesheetColor('primary-color-1-dark-mode', primaryColor1DarkMode);
		this.stylesheetService.setStylesheetColor('primary-color-2-dark-mode', primaryColor2DarkMode);
		this.stylesheetService.setStylesheetColor('primary-color-1-hover', temporaryColor);
		this.stylesheetService.setStylesheetColor('primary-color-2-hover', temporaryColor);
	}

	searchToolSubmit(event: KeyboardEvent) {
		if (event && (event.key === 'Enter' || event.type === 'click') && this.searchbarText) {
			if ((<string>this.searchbarText).length > 3) {
				this.Router.navigateByUrl('search/' + this.searchbarText);
				this.searchbarText = '';
			} else {
				this.NotificationService.setNotificationMessage(this.labels.lbl_min_char_search);
			}
		}
	}

	saveDateFormat(dateFormat: string): void {
		localStorage.setItem('dateFormat', dateFormat);
	}

	logoff(): void {
		this.isModalOpen = false;
		this.AuthLoginService.logoff(this.ProfileService.userData().id, this.ProfileService.userData().idAnalyst);
	}

	setModal(modalMessage: string, modalEvent: any): void {
		this.isModalOpen = true;
		this.modalMessage = modalMessage;
		this.modalEvent = modalEvent;
	}

	closeModal(event: Event): void {
		if (event.target === document.querySelector('#closeModal') || event.target === document.querySelector('#closeModal2')) {
			this.modalMessage = '';
			this.modalEvent = '';
			this.isModalOpen = false;
		}
	}

	array_move(array: any[], old_index: number, new_index: number) {
		while (old_index < 0) {
			old_index += array.length;
		}
		while (new_index < 0) {
			new_index += array.length;
		}
		if (new_index >= array.length) {
			let k = new_index - array.length + 1;
			while (k--) {
				array.push(undefined);
			}
		}
		array.splice(new_index, 0, array.splice(old_index, 1)[0]);
	}

	/*ABI FUNCTIONS*/
	initAbiPosition(): void {
		let delta = 0;
		delta = window.innerWidth < window.innerHeight && window.innerWidth > 767 ? Math.floor(window.innerWidth / 8) : 82;

		this.abiBubbleData.left = window.innerWidth - delta;
		this.abiBubbleData.top = window.innerHeight - delta;
	}

	abiMouseDown(): void {
		this.abiBubbleData.hold = true;
		this.abiBubbleData.holdStart = new Date();
	}

	abiMouseUp(): void {
		this.abiBubbleData.hold = false;
		this.abiBubbleData.holdFinish = new Date();
		this.abiBubbleData.holdDelta = (this.abiBubbleData.holdFinish - this.abiBubbleData.holdStart) / 1000;

		if (this.abiBubbleData.holdDelta <= 0.15) {
			this.abiBubbleData.isOpen = true;
			this.initAbiPosition();
		}
	}

	abiMouseMove(event: MouseEvent): void {
		this.abiBubbleData.left = event.x - 32;
		this.abiBubbleData.top = event.y - 32;
	}
	/*EOABI*/
}
